/* eslint-disable react/no-deprecated */
import { LocaleProvider } from "@douyinfe/semi-ui"
import en_GB from "@douyinfe/semi-ui/lib/es/locale/source/en_GB"
import React from "react"
import { CookiesProvider } from "react-cookie"
import ReactDOM from "react-dom"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import { BifrostProvider } from "./BifrostProvider"
import "./index.css"
import reportWebVitals from "./reportWebVitals"

import Auth0ProviderWithHistory from "./Components/BifrostPageComponent/Auth0PRoviderContext"

if (process.env.NODE_ENV === "production") {
	console.log = () => { }
	console.error = () => { }
	console.debug = () => { }
}

console.log(process.env.REACT_APP_VERSION)

if (process.env.REACT_APP_THEME !== "bifrost") {
	document.title = process.env.REACT_APP_THEME.charAt(0).toUpperCase() + process.env.REACT_APP_THEME.slice(1) + " - Manager"
}

/* If the env is development and mock is enable, start the MSW interrupter to interrupt the http request. */
if (process.env.NODE_ENV === "development" && process.env.REACT_APP_MOCK === "enable") {
	const { worker } = require("./mocks/browser")
	worker.start()
}

ReactDOM.render(
	<React.StrictMode>
		<LocaleProvider locale={en_GB}> {/* Set the default language to English for semi-design UI library */}
			<CookiesProvider>
				<BifrostProvider>
					<BrowserRouter>
						<Auth0ProviderWithHistory>
							<App />
						</Auth0ProviderWithHistory>
					</BrowserRouter>
				</BifrostProvider>
			</CookiesProvider>
		</LocaleProvider>
	</React.StrictMode>,
	document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
